var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "integration-form" },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-select", {
                attrs: {
                  fancy: "",
                  label: _vm.$ct("integration-type"),
                  items: _vm.typeItems,
                },
                model: {
                  value: _vm.integrationType,
                  callback: function ($$v) {
                    _vm.integrationType = $$v
                  },
                  expression: "integrationType",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.integrationType != "manual" && _vm.integrationType != "exact"
        ? _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("sync-active") },
                    model: {
                      value: _vm.enabled,
                      callback: function ($$v) {
                        _vm.enabled = $$v
                      },
                      expression: "enabled",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showExactFields
        ? _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-tabs", {
                    attrs: { tabs: _vm.exactTabs },
                    model: {
                      value: _vm.exactTab,
                      callback: function ($$v) {
                        _vm.exactTab = $$v
                      },
                      expression: "exactTab",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.integrationType == "exact"
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showExactFields || _vm.exactTab == 0,
                  expression: "!showExactFields || exactTab == 0",
                },
              ],
              staticClass: "tab-panel",
            },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      !_vm.exactConnected
                        ? _c("div", { staticClass: "warn" }, [
                            _vm._v(
                              " " + _vm._s(_vm.$ct("connect-exact-first")) + " "
                            ),
                          ])
                        : _c("w-input-autocomplete", {
                            attrs: {
                              fancy: "",
                              label: _vm.$ct("division-label"),
                              items: _vm.divisionMatches,
                              disabled: _vm.loadingDivisions,
                            },
                            on: {
                              focus: _vm.onDivisionFocus,
                              "realtime-value": _vm.onDivisionTextChange,
                              "item-click": _vm.onDivisionPicked,
                              blur: _vm.onDivisionBlur,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ item }) {
                                    return [
                                      _c("div", [
                                        _c("strong", [
                                          _vm._v(_vm._s(item.Description)),
                                        ]),
                                        _vm._v(" (" + _vm._s(item.Code) + ")"),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1107016687
                            ),
                            model: {
                              value: _vm.divisionSearch,
                              callback: function ($$v) {
                                _vm.divisionSearch = $$v
                              },
                              expression: "divisionSearch",
                            },
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.showExactFields
                ? [
                    _c("hr", { staticClass: "divider" }),
                    _c(
                      "w-row",
                      [
                        _c(
                          "w-col",
                          { attrs: { xs: "12", md: "6" } },
                          [
                            _c("w-checkbox", {
                              attrs: { label: _vm.$ct("sync-active") },
                              model: {
                                value: _vm.enabled,
                                callback: function ($$v) {
                                  _vm.enabled = $$v
                                },
                                expression: "enabled",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "w-col",
                          { attrs: { xs: "12", md: "6" } },
                          [
                            _c("w-checkbox", {
                              attrs: { label: _vm.$ct("attach-pdf") },
                              model: {
                                value: _vm.attachPdf,
                                callback: function ($$v) {
                                  _vm.attachPdf = $$v
                                },
                                expression: "attachPdf",
                              },
                            }),
                            _c("p", { staticClass: "hint" }, [
                              _vm._v(_vm._s(_vm.$ct("attach-pdf-hint"))),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm.showExactFields
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.exactTab == 1,
                  expression: "exactTab == 1",
                },
              ],
              staticClass: "tab-panel",
            },
            [
              _c("p", { staticClass: "section-subtitle" }, [
                _vm._v(_vm._s(_vm.$ct("sales-section-hint"))),
              ]),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-select", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("sales-export-mode-label"),
                          items: _vm.salesExportModeItems,
                        },
                        model: {
                          value: _vm.salesExportMode,
                          callback: function ($$v) {
                            _vm.salesExportMode = $$v
                          },
                          expression: "salesExportMode",
                        },
                      }),
                      _c("p", { staticClass: "hint" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$ct(
                              _vm.salesExportMode == "entry"
                                ? "sales-export-mode-entry-hint"
                                : "sales-export-mode-invoice-hint"
                            )
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("hr", { staticClass: "divider" }),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-select", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("journal-label"),
                          items: _vm.journalItems,
                          disabled: _vm.loadingSubData,
                        },
                        model: {
                          value: _vm.journal,
                          callback: function ($$v) {
                            _vm.journal = $$v
                          },
                          expression: "journal",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-select", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("default-vat-code-label"),
                          items: _vm.vatCodeItems,
                          disabled: _vm.loadingSubData,
                        },
                        model: {
                          value: _vm.defaultVatCode,
                          callback: function ($$v) {
                            _vm.defaultVatCode = $$v
                          },
                          expression: "defaultVatCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("w-col", { attrs: { xs: "12" } }, [
                    _c(
                      "div",
                      { staticClass: "mapping-row" },
                      [
                        _c("w-checkbox", {
                          attrs: {
                            value: _vm.vatMappingActive,
                            label: _vm.$ct("vat-overrides.active"),
                          },
                          on: {
                            input: function ($event) {
                              return _vm.onVatMappingToggle($event)
                            },
                          },
                        }),
                        _vm.vatMappingActive
                          ? _c(
                              "w-link",
                              {
                                on: {
                                  click: function ($event) {
                                    _vm.vatModalOpen = true
                                  },
                                },
                              },
                              [
                                _c("w-fa", { attrs: { icon: "pencil-alt" } }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$ct("vat-overrides.manage", {
                                        count: _vm.vatCodeOverrides.length,
                                      })
                                    ) +
                                    " "
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c("p", { staticClass: "hint" }, [
                      _vm._v(_vm._s(_vm.$ct("vat-overrides.hint"))),
                    ]),
                  ]),
                ],
                1
              ),
              _c("hr", { staticClass: "divider" }),
              _c(
                "w-row",
                [
                  _c("w-col", { attrs: { xs: "12" } }, [
                    _c("p", { staticClass: "hint" }, [
                      _vm._v(" " + _vm._s(_vm.$ct("item-or-gl-hint")) + " "),
                    ]),
                  ]),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-input-autocomplete", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("default-item-label"),
                          items: _vm.items,
                          "input-delay": 200,
                        },
                        on: {
                          "realtime-value": _vm.onItemTextChange,
                          input: _vm.searchItems,
                          "item-click": _vm.onItemPicked,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ item }) {
                                return [
                                  _c("div", [
                                    _c("strong", [_vm._v(_vm._s(item.Code))]),
                                    _vm._v(" — " + _vm._s(item.Description)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3931728785
                        ),
                        model: {
                          value: _vm.itemSearch,
                          callback: function ($$v) {
                            _vm.itemSearch = $$v
                          },
                          expression: "itemSearch",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-input-autocomplete", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("default-gl-account-label"),
                          items: _vm.glAccounts,
                          "input-delay": 200,
                        },
                        on: {
                          "realtime-value": _vm.onGLAccountTextChange,
                          input: _vm.searchGLAccounts,
                          "item-click": _vm.onGLAccountPicked,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ item }) {
                                return [
                                  _c("div", [
                                    _c("strong", [_vm._v(_vm._s(item.Code))]),
                                    _vm._v(" — " + _vm._s(item.Description)),
                                  ]),
                                  _c("div", { staticClass: "gl-hint" }, [
                                    _vm._v(
                                      " Type " +
                                        _vm._s(item.Type) +
                                        " · " +
                                        _vm._s(item.BalanceType) +
                                        " "
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2153006699
                        ),
                        model: {
                          value: _vm.glAccountSearch,
                          callback: function ($$v) {
                            _vm.glAccountSearch = $$v
                          },
                          expression: "glAccountSearch",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input-autocomplete", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("leeggoed-gl-account-label"),
                          items: _vm.leeggoedGLAccounts,
                          "input-delay": 200,
                        },
                        on: {
                          "realtime-value": _vm.onLeeggoedGLTextChange,
                          input: _vm.searchLeeggoedGL,
                          "item-click": _vm.onLeeggoedGLPicked,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ item }) {
                                return [
                                  _c("div", [
                                    _c("strong", [_vm._v(_vm._s(item.Code))]),
                                    _vm._v(" — " + _vm._s(item.Description)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3931728785
                        ),
                        model: {
                          value: _vm.leeggoedGLAccountSearch,
                          callback: function ($$v) {
                            _vm.leeggoedGLAccountSearch = $$v
                          },
                          expression: "leeggoedGLAccountSearch",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("hr", { staticClass: "divider" }),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("auto-sync-sales") },
                        model: {
                          value: _vm.autoSyncSales,
                          callback: function ($$v) {
                            _vm.autoSyncSales = $$v
                          },
                          expression: "autoSyncSales",
                        },
                      }),
                      _c("p", { staticClass: "hint" }, [
                        _vm._v(_vm._s(_vm.$ct("auto-sync-hint"))),
                      ]),
                    ],
                    1
                  ),
                  _vm.salesExportMode != "entry"
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: { label: _vm.$ct("auto-process-sales") },
                            model: {
                              value: _vm.autoProcessSales,
                              callback: function ($$v) {
                                _vm.autoProcessSales = $$v
                              },
                              expression: "autoProcessSales",
                            },
                          }),
                          _c("p", { staticClass: "hint" }, [
                            _vm._v(_vm._s(_vm.$ct("auto-process-sales-hint"))),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showExactFields
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.exactTab == 2,
                  expression: "exactTab == 2",
                },
              ],
              staticClass: "tab-panel",
            },
            [
              _c("p", { staticClass: "section-subtitle" }, [
                _vm._v(_vm._s(_vm.$ct("purchase-section-hint"))),
              ]),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-select", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("purchase-journal-label"),
                          items: _vm.purchaseJournalItems,
                          disabled: _vm.loadingSubData,
                        },
                        model: {
                          value: _vm.purchaseJournal,
                          callback: function ($$v) {
                            _vm.purchaseJournal = $$v
                          },
                          expression: "purchaseJournal",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-select", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("default-purchase-vat-code-label"),
                          items: _vm.purchaseVatCodeItems,
                          disabled: _vm.loadingSubData,
                        },
                        model: {
                          value: _vm.defaultPurchaseVatCode,
                          callback: function ($$v) {
                            _vm.defaultPurchaseVatCode = $$v
                          },
                          expression: "defaultPurchaseVatCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input-autocomplete", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("default-purchase-gl-account-label"),
                          items: _vm.purchaseGLAccounts,
                          "input-delay": 200,
                        },
                        on: {
                          "realtime-value": _vm.onPurchaseGLTextChange,
                          input: _vm.searchPurchaseGL,
                          "item-click": _vm.onPurchaseGLPicked,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ item }) {
                                return [
                                  _c("div", [
                                    _c("strong", [_vm._v(_vm._s(item.Code))]),
                                    _vm._v(" — " + _vm._s(item.Description)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3931728785
                        ),
                        model: {
                          value: _vm.purchaseGLAccountSearch,
                          callback: function ($$v) {
                            _vm.purchaseGLAccountSearch = $$v
                          },
                          expression: "purchaseGLAccountSearch",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("w-col", { attrs: { xs: "12" } }, [
                    _c(
                      "div",
                      { staticClass: "mapping-row" },
                      [
                        _c("w-checkbox", {
                          attrs: {
                            value: _vm.purchaseVatMappingActive,
                            label: _vm.$ct("vat-overrides.active"),
                          },
                          on: {
                            input: function ($event) {
                              return _vm.onPurchaseVatMappingToggle($event)
                            },
                          },
                        }),
                        _vm.purchaseVatMappingActive
                          ? _c(
                              "w-link",
                              {
                                on: {
                                  click: function ($event) {
                                    _vm.purchaseVatModalOpen = true
                                  },
                                },
                              },
                              [
                                _c("w-fa", { attrs: { icon: "pencil-alt" } }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$ct("vat-overrides.manage", {
                                        count:
                                          _vm.purchaseVatCodeOverrides.length,
                                      })
                                    ) +
                                    " "
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c("p", { staticClass: "hint" }, [
                      _vm._v(_vm._s(_vm.$ct("vat-overrides.purchase-hint"))),
                    ]),
                  ]),
                ],
                1
              ),
              _c("hr", { staticClass: "divider" }),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("auto-sync-purchases") },
                        model: {
                          value: _vm.autoSyncPurchases,
                          callback: function ($$v) {
                            _vm.autoSyncPurchases = $$v
                          },
                          expression: "autoSyncPurchases",
                        },
                      }),
                      _c("p", { staticClass: "hint" }, [
                        _vm._v(_vm._s(_vm.$ct("auto-sync-hint"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showWinbooksFields
        ? _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-head" }, [
                _c("span", { staticClass: "section-title" }, [
                  _vm._v(_vm._s(_vm.$ct("wb.journals-title"))),
                ]),
              ]),
              _c("p", { staticClass: "section-subtitle" }, [
                _vm._v(_vm._s(_vm.$ct("wb.journals-hint"))),
              ]),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "8", md: "4" } },
                    [
                      _c("w-input", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("wb.journal-invoice"),
                        },
                        model: {
                          value: _vm.wbJournalInvoice,
                          callback: function ($$v) {
                            _vm.wbJournalInvoice = $$v
                          },
                          expression: "wbJournalInvoice",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "4", md: "2" } },
                    [
                      _c("w-input", {
                        attrs: { fancy: "", label: _vm.$ct("wb.journal-type") },
                        model: {
                          value: _vm.wbJournalInvoiceType,
                          callback: function ($$v) {
                            _vm.wbJournalInvoiceType = $$v
                          },
                          expression: "wbJournalInvoiceType",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "8", md: "4" } },
                    [
                      _c("w-input", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("wb.journal-credit"),
                        },
                        model: {
                          value: _vm.wbJournalCredit,
                          callback: function ($$v) {
                            _vm.wbJournalCredit = $$v
                          },
                          expression: "wbJournalCredit",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "4", md: "2" } },
                    [
                      _c("w-input", {
                        attrs: { fancy: "", label: _vm.$ct("wb.journal-type") },
                        model: {
                          value: _vm.wbJournalCreditType,
                          callback: function ($$v) {
                            _vm.wbJournalCreditType = $$v
                          },
                          expression: "wbJournalCreditType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showWinbooksFields
        ? _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-head" }, [
                _c("span", { staticClass: "section-title" }, [
                  _vm._v(_vm._s(_vm.$ct("wb.accounts-title"))),
                ]),
              ]),
              _c("p", { staticClass: "section-subtitle" }, [
                _vm._v(_vm._s(_vm.$ct("wb.accounts-hint"))),
              ]),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-input", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("wb.central-account"),
                        },
                        model: {
                          value: _vm.wbCentralAccount,
                          callback: function ($$v) {
                            _vm.wbCentralAccount = $$v
                          },
                          expression: "wbCentralAccount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-input", {
                        attrs: { fancy: "", label: _vm.$ct("wb.vat-account") },
                        model: {
                          value: _vm.wbVatAccount,
                          callback: function ($$v) {
                            _vm.wbVatAccount = $$v
                          },
                          expression: "wbVatAccount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-input", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("wb.default-ledger-account"),
                        },
                        model: {
                          value: _vm.wbDefaultLedgerAccount,
                          callback: function ($$v) {
                            _vm.wbDefaultLedgerAccount = $$v
                          },
                          expression: "wbDefaultLedgerAccount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-input", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("wb.leeggoed-account"),
                        },
                        model: {
                          value: _vm.wbLeeggoedAccount,
                          callback: function ($$v) {
                            _vm.wbLeeggoedAccount = $$v
                          },
                          expression: "wbLeeggoedAccount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-select", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("wb.account-length"),
                          items: _vm.wbAccountLengthItems,
                        },
                        model: {
                          value: _vm.wbAccountLength,
                          callback: function ($$v) {
                            _vm.wbAccountLength = $$v
                          },
                          expression: "wbAccountLength",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-select", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("wb.customer-number-field"),
                          items: _vm.wbCustomerNumberFieldItems,
                        },
                        model: {
                          value: _vm.wbCustomerNumberField,
                          callback: function ($$v) {
                            _vm.wbCustomerNumberField = $$v
                          },
                          expression: "wbCustomerNumberField",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-input", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("wb.book-year-code"),
                        },
                        model: {
                          value: _vm.wbBookYearCode,
                          callback: function ($$v) {
                            _vm.wbBookYearCode = $$v
                          },
                          expression: "wbBookYearCode",
                        },
                      }),
                      _c("p", { staticClass: "hint" }, [
                        _vm._v(_vm._s(_vm.$ct("wb.book-year-code-hint"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("wb.quarter-periods") },
                        model: {
                          value: _vm.wbQuarterPeriods,
                          callback: function ($$v) {
                            _vm.wbQuarterPeriods = $$v
                          },
                          expression: "wbQuarterPeriods",
                        },
                      }),
                      _c("p", { staticClass: "hint" }, [
                        _vm._v(_vm._s(_vm.$ct("wb.quarter-periods-hint"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showWinbooksFields
        ? _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-head" }, [
                _c("span", { staticClass: "section-title" }, [
                  _vm._v(_vm._s(_vm.$ct("wb.vat-codes-title"))),
                ]),
              ]),
              _c("p", { staticClass: "section-subtitle" }, [
                _vm._v(_vm._s(_vm.$ct("wb.vat-codes-hint"))),
              ]),
              _vm._l(_vm.wbVatCodes, function (entry, index) {
                return _c(
                  "w-row",
                  { key: index, staticClass: "vat-code-row" },
                  [
                    _c(
                      "w-col",
                      { attrs: { xs: "12", md: "4" } },
                      [
                        _c("w-select", {
                          attrs: {
                            fancy: "",
                            label: _vm.$ct("wb.vat-code-regime"),
                            items: _vm.wbRegimeItems,
                          },
                          model: {
                            value: entry.regime,
                            callback: function ($$v) {
                              _vm.$set(entry, "regime", $$v)
                            },
                            expression: "entry.regime",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "w-col",
                      { attrs: { xs: "3", md: "2" } },
                      [
                        _c("w-input", {
                          attrs: {
                            fancy: "",
                            label: _vm.$ct("wb.vat-code-rate"),
                          },
                          model: {
                            value: entry.rateText,
                            callback: function ($$v) {
                              _vm.$set(entry, "rateText", $$v)
                            },
                            expression: "entry.rateText",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "w-col",
                      { attrs: { xs: "3", md: "2" } },
                      [
                        _c("w-input", {
                          attrs: {
                            fancy: "",
                            label: _vm.$ct("wb.vat-code-code"),
                          },
                          model: {
                            value: entry.code,
                            callback: function ($$v) {
                              _vm.$set(entry, "code", $$v)
                            },
                            expression: "entry.code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "w-col",
                      { attrs: { xs: "4", md: "3" } },
                      [
                        _c("w-input", {
                          attrs: {
                            fancy: "",
                            label: _vm.$ct("wb.vat-code-account"),
                          },
                          model: {
                            value: entry.account,
                            callback: function ($$v) {
                              _vm.$set(entry, "account", $$v)
                            },
                            expression: "entry.account",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "w-col",
                      {
                        staticClass: "vat-code-remove",
                        attrs: { xs: "2", md: "1" },
                      },
                      [
                        _c("w-button", {
                          staticClass: "cancel",
                          attrs: { icon: "trash" },
                          on: {
                            click: function ($event) {
                              return _vm.removeVatCode(index)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "w-button",
                {
                  attrs: { icon: "plus" },
                  on: {
                    click: function ($event) {
                      return _vm.addVatCode()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("wb.add-vat-code")) + " ")]
              ),
            ],
            2
          )
        : _vm._e(),
      _vm.showYukiFields
        ? _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-head" }, [
                _c("span", { staticClass: "section-title" }, [
                  _vm._v(_vm._s(_vm.$ct("yuki.connection-title"))),
                ]),
              ]),
              _c("p", { staticClass: "section-subtitle" }, [
                _vm._v(_vm._s(_vm.$ct("yuki.connection-hint"))),
              ]),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-input", {
                        attrs: { fancy: "", label: _vm.$ct("yuki.api-key") },
                        model: {
                          value: _vm.yukiApiKey,
                          callback: function ($$v) {
                            _vm.yukiApiKey = $$v
                          },
                          expression: "yukiApiKey",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-select", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("yuki.domain"),
                          items: _vm.yukiDomainItems,
                        },
                        model: {
                          value: _vm.yukiDomain,
                          callback: function ($$v) {
                            _vm.yukiDomain = $$v
                          },
                          expression: "yukiDomain",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "9", md: "5" } },
                    [
                      _c("w-select", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("yuki.administration"),
                          items: _vm.yukiAdministrationItems,
                          disabled: _vm.loadingYukiAdministrations,
                        },
                        model: {
                          value: _vm.yukiAdministrationId,
                          callback: function ($$v) {
                            _vm.yukiAdministrationId = $$v
                          },
                          expression: "yukiAdministrationId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    {
                      staticClass: "yuki-admin-refresh",
                      attrs: { xs: "3", md: "1" },
                    },
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("yuki.load-administrations"),
                              expression: "$ct('yuki.load-administrations')",
                            },
                          ],
                          attrs: {
                            disabled:
                              !_vm.yukiApiKey.trim() ||
                              _vm.loadingYukiAdministrations,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.loadYukiAdministrations()
                            },
                          },
                        },
                        [
                          _c("w-fa", {
                            attrs: {
                              icon: _vm.loadingYukiAdministrations
                                ? "spinner"
                                : "sync",
                              spin: _vm.loadingYukiAdministrations,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c("w-input", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("yuki.default-gl-account"),
                        },
                        model: {
                          value: _vm.yukiDefaultGLAccount,
                          callback: function ($$v) {
                            _vm.yukiDefaultGLAccount = $$v
                          },
                          expression: "yukiDefaultGLAccount",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.yukiAdministrations.length == 0
                    ? _c("w-col", { attrs: { xs: "12" } }, [
                        _c("p", { staticClass: "hint" }, [
                          _vm._v(_vm._s(_vm.$ct("yuki.administration-hint"))),
                        ]),
                      ])
                    : _vm._e(),
                  _c("w-col", { attrs: { xs: "12" } }, [
                    _c("p", { staticClass: "hint" }, [
                      _vm._v(_vm._s(_vm.$ct("yuki.default-gl-account-hint"))),
                    ]),
                  ]),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("yuki.attach-pdf") },
                        model: {
                          value: _vm.attachPdf,
                          callback: function ($$v) {
                            _vm.attachPdf = $$v
                          },
                          expression: "attachPdf",
                        },
                      }),
                      _c("p", { staticClass: "hint" }, [
                        _vm._v(_vm._s(_vm.$ct("yuki.attach-pdf-hint"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: { label: _vm.$ct("yuki.process") },
                        model: {
                          value: _vm.yukiProcess,
                          callback: function ($$v) {
                            _vm.yukiProcess = $$v
                          },
                          expression: "yukiProcess",
                        },
                      }),
                      _c("p", { staticClass: "hint" }, [
                        _vm._v(_vm._s(_vm.$ct("yuki.process-hint"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showClearfactsFields
        ? _c(
            "div",
            { staticClass: "settings-section" },
            [
              _c("div", { staticClass: "section-head" }, [
                _c("span", { staticClass: "section-title" }, [
                  _vm._v(_vm._s(_vm.$ct("cf.connection-title"))),
                ]),
              ]),
              _c("p", { staticClass: "section-subtitle" }, [
                _vm._v(_vm._s(_vm.$ct("cf.connection-hint"))),
              ]),
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-select", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("cf.auth-method"),
                          items: _vm.cfAuthMethodItems,
                        },
                        model: {
                          value: _vm.cfAuthMethod,
                          callback: function ($$v) {
                            _vm.cfAuthMethod = $$v
                          },
                          expression: "cfAuthMethod",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.cfAuthMethod == "token"
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: { fancy: "", label: _vm.$ct("cf.api-key") },
                            model: {
                              value: _vm.cfApiKey,
                              callback: function ($$v) {
                                _vm.cfApiKey = $$v
                              },
                              expression: "cfApiKey",
                            },
                          }),
                          _c("p", { staticClass: "hint" }, [
                            _vm._v(_vm._s(_vm.$ct("cf.api-key-hint"))),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.cfAuthMethod == "oauth" && !_vm.clearfactsConnected
                ? _c("p", { staticClass: "hint" }, [
                    _vm._v(_vm._s(_vm.$ct("cf.not-connected"))),
                  ])
                : _vm.cfCanChooseAdministration
                ? _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "9", md: "7" } },
                        [
                          _c("w-select", {
                            attrs: {
                              fancy: "",
                              label: _vm.$ct("cf.administration"),
                              items: _vm.cfAdministrationItems,
                              disabled: _vm.loadingCfAdministrations,
                            },
                            model: {
                              value: _vm.cfVatNumber,
                              callback: function ($$v) {
                                _vm.cfVatNumber = $$v
                              },
                              expression: "cfVatNumber",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        {
                          staticClass: "yuki-admin-refresh",
                          attrs: { xs: "3", md: "1" },
                        },
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("cf.load-administrations"),
                                  expression: "$ct('cf.load-administrations')",
                                },
                              ],
                              attrs: { disabled: _vm.loadingCfAdministrations },
                              on: {
                                click: function ($event) {
                                  return _vm.loadClearfactsAdministrations()
                                },
                              },
                            },
                            [
                              _c("w-fa", {
                                attrs: {
                                  icon: _vm.loadingCfAdministrations
                                    ? "spinner"
                                    : "sync",
                                  spin: _vm.loadingCfAdministrations,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.cfAdministrations.length == 0
                        ? _c("w-col", { attrs: { xs: "12" } }, [
                            _c("p", { staticClass: "hint" }, [
                              _vm._v(_vm._s(_vm.$ct("cf.administration-hint"))),
                            ]),
                          ])
                        : _vm._e(),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("w-select", {
                            attrs: {
                              fancy: "",
                              label: _vm.$ct("cf.sales-format"),
                              items: _vm.cfFormatItems,
                            },
                            model: {
                              value: _vm.cfSalesFormat,
                              callback: function ($$v) {
                                _vm.cfSalesFormat = $$v
                              },
                              expression: "cfSalesFormat",
                            },
                          }),
                          _c("p", { staticClass: "hint" }, [
                            _vm._v(_vm._s(_vm.$ct("cf.sales-format-hint"))),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("w-select", {
                            attrs: {
                              fancy: "",
                              label: _vm.$ct("cf.purchase-format"),
                              items: _vm.cfFormatItems,
                            },
                            model: {
                              value: _vm.cfPurchaseFormat,
                              callback: function ($$v) {
                                _vm.cfPurchaseFormat = $$v
                              },
                              expression: "cfPurchaseFormat",
                            },
                          }),
                          _c("p", { staticClass: "hint" }, [
                            _vm._v(_vm._s(_vm.$ct("cf.purchase-format-hint"))),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-checkbox", {
                            attrs: { label: _vm.$ct("auto-sync-sales") },
                            model: {
                              value: _vm.autoSyncSales,
                              callback: function ($$v) {
                                _vm.autoSyncSales = $$v
                              },
                              expression: "autoSyncSales",
                            },
                          }),
                          _c("w-checkbox", {
                            attrs: { label: _vm.$ct("auto-sync-purchases") },
                            model: {
                              value: _vm.autoSyncPurchases,
                              callback: function ($$v) {
                                _vm.autoSyncPurchases = $$v
                              },
                              expression: "autoSyncPurchases",
                            },
                          }),
                          _c("p", { staticClass: "hint" }, [
                            _vm._v(_vm._s(_vm.$ct("auto-sync-hint"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "form-actions" },
        [
          _c(
            "w-button",
            {
              staticClass: "primary",
              attrs: { disabled: !_vm.canSave },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("save")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.vatModalOpen,
            callback: function ($$v) {
              _vm.vatModalOpen = $$v
            },
            expression: "vatModalOpen",
          },
        },
        [
          _vm.vatModalOpen
            ? _c("app-exact-vat-overrides-modal", {
                attrs: {
                  overrides: _vm.vatCodeOverrides,
                  "vat-code-items": _vm.vatCodeItems,
                  "regime-items": _vm.salesVatRegimeItems,
                },
                on: {
                  close: function ($event) {
                    _vm.vatModalOpen = false
                  },
                  save: function ($event) {
                    return _vm.onVatOverridesSaved($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.purchaseVatModalOpen,
            callback: function ($$v) {
              _vm.purchaseVatModalOpen = $$v
            },
            expression: "purchaseVatModalOpen",
          },
        },
        [
          _vm.purchaseVatModalOpen
            ? _c("app-exact-vat-overrides-modal", {
                attrs: {
                  overrides: _vm.purchaseVatCodeOverrides,
                  "vat-code-items": _vm.purchaseVatCodeItems,
                  "regime-items": _vm.purchaseVatRegimeItems,
                },
                on: {
                  close: function ($event) {
                    _vm.purchaseVatModalOpen = false
                  },
                  save: function ($event) {
                    return _vm.onPurchaseVatOverridesSaved($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }